var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-sidebar" },
    [
      _vm._l(_vm.accordions, function(accordion, index) {
        return _c(
          "DrawerAccordion",
          {
            key: index,
            attrs: {
              id: "accordion-" + index,
              title: accordion.title,
              openByDefault: false
            }
          },
          [
            _c("div", {
              staticClass:
                "onboarding-sidebar__accordion-content typographies-paragraph-medium-regular",
              domProps: { innerHTML: _vm._s(accordion.content) }
            })
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "onboarding-sidebar__help typographies-paragraph-medium-bold"
        },
        [
          _c("CompassIcon", {
            staticClass: "onboarding-sidebar__help-icon",
            attrs: { icon: "help-circle-fill", size: "small" }
          }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t.__("pdp.mandate.OnboardingSidebar.help")) +
              "\n    "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "onboarding-sidebar__tag-list" },
        _vm._l(_vm.tagList, function(tag, index) {
          return _c(
            "CompassTag",
            { key: index, attrs: { color: "stroked", icon: "success-circle" } },
            [_vm._v("\n            " + _vm._s(tag) + "\n        ")]
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }